import React, { forwardRef, useState } from "react";
import { Input } from "./input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with accessible show/hide toggle.
 * - Toggle button is keyboard-focusable (tabIndex=0) and announces state via aria-label + aria-pressed.
 * - Uses type="button" to never submit the enclosing form.
 * - Extends shadcn Input for consistent styling.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testId, id, autoComplete = "current-password", ...rest },
  ref
) {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible((v) => !v);

  return (
    <div className="relative">
      <Input
        ref={ref}
        id={id}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        data-testid={testId}
        className={`pr-11 ${className}`}
        {...rest}
      />
      <button
        type="button"
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
        aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
        aria-pressed={visible}
        aria-controls={id}
        tabIndex={0}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 inline-flex items-center justify-center rounded text-slate-500 hover:text-[#0AA89C] focus:outline-none focus:ring-2 focus:ring-[#0AA89C]/40 focus:text-[#0AA89C] transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export { PasswordInput };
export default PasswordInput;
